import request from '@/utils/request'

export function getValidateCode (query) {
  return request({
    url: '/api/merchant/validate-code/image/code',
    method: 'get',
    params: query
  })
}

export function checkValidateImage (validateCode) {
  return request({
    url: '/api/merchant/validate-code/image-validate',
    method: 'post',
    data: {
      validateCode
    }
  })
}

export function getValidateSms (query) {
  return request({
    url: '/api/merchant/validate-code/sms/send',
    method: 'post',
    data: query
  })
}

export function getValidateEmail (query) {
  return request({
    url: '/api/merchant/validate-code/email/send/simple',
    method: 'post',
    data: query
  })
}

export function checkValidateSms (mobile, validateCode, type) {
  return request({
    url: '/api/merchant/validate-code/sms/validate',
    method: 'post',
    data: {
      mobile,
      validateCode,
      type
    }
  })
}

export function getApiCategory (query) {
  return request({
    url: '/api/merchant/api-category/tree',
    method: 'get',
    data: {
      aboutNoPublish: query.aboutNoPublish
    }
  })
}

export function loginSendSms (query) {
  return request({
    url: '/api/merchant/account/login/sendSms',
    method: 'post',
    data: query
  })
}

export function loginAccountSms (query) {
  return request({
    url: '/api/merchant/account/login/sms',
    method: 'post',
    data: query
  })
}

export function sendSmsSimple (query) {
  return request({
    url: '/api/merchant/validate-code/sms/send/simple',
    method: 'post',
    data: query
  })
}

export function validataSmsCode (query) {
  return request({
    url: '/api/merchant/account/retrievePassword/validataSmsCode',
    method: 'post',
    data: query
  })
}

export function validataEmailCode (query) {
  return request({
    url: '/api/merchant/account/retry-pwd/email',
    method: 'post',
    data: query
  })
}

export function setSmsPassword (query) {
  return request({
    url: '/api/merchant/account/setPassword',
    method: 'post',
    data: query
  })
}

export function setEmailPassword (query) {
  return request({
    url: '/api/merchant/account/setPassword/email',
    method: 'post',
    data: query
  })
}

export function getProductTree (query) {
  return request({
    url: '/api/merchant/business/product/api-tree',
    method: 'get',
    params: query
  })
}

export function getActivityImage (query) {
  return request({
    url: '/api/merchant/activity/getActivityImage',
    method: 'get',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/services/common.js